module.exports = __webpack_public_path__ + "static/media/sh.80b5cc58.svg";